import styled, { css } from 'styled-components';
import { layout } from '../../../../package.json';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  width: 100vw;
  max-width: 1400px;
  height: 100%;
  margin: 0 auto;
  padding: 0 2%;
`;

export const ContainerBody = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  height: 100%;
  min-height: 400px;
  margin: 0 auto;
  margin-top: 3rem;

  @media (max-width: ${layout.tablet}) {
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

`;

export const ContainerLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
 
  flex: 1;
  width: 100%;
  height: 100%;
  min-width: 12rem;
  max-width: 20rem;

  @media (max-width: ${layout.tablet}) {
    /* display: none; */
    margin: 0 auto;
    max-width: 100%;
    padding: 0 2%;
    margin-bottom: 3rem;
  }

  @media (max-width: 650px) {
    max-width: 25rem;
  }
`;

export const ContainerMenu = styled.div`
  width: 100%;
  min-height: 25rem;

  @media (max-width: ${layout.tablet}) {
    display: flex;
    justify-content: center;
    min-height: 3.12rem;
    flex-wrap:wrap;
    gap: 0.5rem;
  }
`;

interface ContainerMenuItemProps {
  active?: boolean;
}

export const ContainerMenuItem = styled.div<ContainerMenuItemProps>`
  width: 100%;
  height: 100%;
  border: 1px solid var(--primary);
  border-radius: 6px;
  cursor: pointer;

  & + div {
    margin-top: 0.37rem;
  }

  ${props => props.active === true &&
    css`
      background-color: var(--primary);
    `}


  span {
    text-align: center;
    line-height: 3.12rem;
    margin-left: 1rem;
    ${props => props.active === false &&
    css`
        color: var(--primary);
      `}

      ${props => props.active === true &&
    css`
        color: #fff;
      `}

    svg {
      padding-top: 0.31rem;
      font-size: 1.87rem;
    }
  }

  :hover{

    background-color: var(--primary);

    span {
      color: #fff;
    }

  }

  @media (max-width: ${layout.tablet}) {
    display: flex;
    align-items:center;
    max-width: 9rem;
    & + div {
      margin-top: 0;
    }
    
    span {
      text-align: center;
      margin: 0 auto;
    }
  }

  @media (max-width: ${layout.mobile}) {
    display: flex;
    align-items:center;
    max-width: 8rem;
  }
`;


export const ContainerRight = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  width: 100%;
  max-width: 60rem;
  min-height: 400px;
  border: 1px solid var(--primary);
  margin-left: 25px;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: #f4f4f4;

  padding: 3rem;

  @media (max-width: ${layout.desktop}) {
    max-width: 50rem;
  }
  @media (max-width: ${layout.tablet}) {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 3rem;
    padding: 2rem;
  }
  @media (max-width: ${layout.mobile}) {
    padding: 1rem;
  }
`;
